import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useState } from "react"



const EditEmp = () =>{


     const navigate = useNavigate()
       const { state } = useLocation();
        const [files, setFiles] = useState({});
       const employee = state?.employee;
       console.log(employee);

      const [form, setForm] = useState({
                id:employee?.id || '',
                name:employee?.name || '',
                email:employee?.email || '',
                phone:employee?.phone || '',
                password:employee?.password || '',
                address:employee?.address || '',
                city:employee?.city || '',
                state:employee?.state || '', 
                 pincode:employee?.pincode || '',
                 short_name:employee?.short_name || '',
                fax:employee?.fax || '',
                url:employee?.url || '',
                pan:employee?.pan || '',
                gst:employee?.gst || '',
                esic_no:employee?.esic_no || '',
                esic_acct:employee?.esic_acct || '',
                bank_name:employee?.bank_name || '',
                esic_office:employee?.esic_office || '',
                acc_no:employee?.acc_no || '',
                pf_no:employee?.pf_no || '',
                ifsc:employee?.ifsc || '',
                pincode:employee?.pincode || '',
                aadhaar:employee?.aadhaar ||'' ,
                bill:employee?.bill || ''
         });

   
  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFiles({ ...files, [e.target.name]: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    Object.keys(form).forEach((key) => {
      formData.append(key, form[key]);
    });

    // Append new files only if selected
    Object.keys(files).forEach((key) => {
      if (files[key]) formData.append(key, files[key]);
    });

    try {
      const res = await axios.put(
        `https://api.skyguard.group/api/update-employee/${form.id}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" }
        }
      );
    //   alert(res.data.message);
         setTimeout(() => {
    window.location.reload();
      navigate("/admin/employee");
  }, 2000);


      
    } catch (err) {
      console.error(err);
      alert("Update failed!");
    }
  };
    return(
        <>
           <div className='main-section'>
                         <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                             <h3 className='my-3 fw-bold fs-5 golos'>Edit Employee</h3>

                             <div className='card p-3 mb-3'>
                         <form onSubmit={handleSubmit} >

                            <h5 className="mt-3 ">Basic Info</h5>

                            <hr />

                            <div className='row g-3'>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="name" placeholder="Name" value={form.name} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="email" placeholder="Email" value={form.email} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="number" className="form-control" name="phone" placeholder="Phone No" value={form.phone} onChange={handleInputChange} />
                                </div>

                                <div className="col-md-4">
                                    <input type="password" className="form-control" name="password" placeholder="Password" value={form.password} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="address" placeholder="address" value={form.address} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="city" placeholder="city" value={form.city} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="state" placeholder="state" value={form.state} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-4">
                                    <input type="text" className="form-control" name="pincode" placeholder="Pincode" value={form.pincode} onChange={handleInputChange} />
                                </div>
                                 <div className="col-md-4">
                                    <input type="text" className="form-control" name="short_name" placeholder="Short Name " value={form.short_name} onChange={handleInputChange} />
                                </div>








                              

                                <h5 className="mt-4">Bank Details</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="bank_name" placeholder="Bank Name" value={form.bank_name} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="acc_no" placeholder="Account Number" value={form.acc_no} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="branch" placeholder="Branch" value={form.branch} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="ifsc" placeholder="IFSC" value={form.ifsc} onChange={handleInputChange} />
                                    </div>


                                </div>

                                <h5 className="mt-4">ESIC Details</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="esic_no" placeholder="ESIC Number" value={form.esic_no} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="esic_acct" placeholder="ESIC Acctount" value={form.esic_acct} onChange={handleInputChange} />
                                    </div>

                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="esic_office" placeholder="ESIC Office" value={form.esic_office} onChange={handleInputChange} />
                                    </div>

                                </div>

                                <h5 className="mt-4">Pan Details</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label>Enter Your Pan</label>
                                        <input type="text" className="form-control" name="pan" placeholder="Pan" value={form.pan} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Upload Your Pan</label>
                                        <input type="file" className="form-control" name="pan_img" accept="image/*,application/pdf"  onChange={handleFileChange} />
                                    </div>

                                </div>
                                <h5 className="mt-4">Aadhar Details</h5>
                                <hr />
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label>Enter Your Aadhaar Number</label>
                                        <input type="text" className="form-control" name="aadhaar" placeholder="Aahaar Number" value={form.aadhaar} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Upload Your Front Aadhaar Image</label>
                                        <input type="file" className="form-control" name="aadhaar_front" accept="image/*,application/pdf"  onChange={handleFileChange} />
                                    </div>

                                    <div className="col-md-4">
                                        <label>Upload Your Back Aadhaar Image</label>
                                        <input type="file" className="form-control" name="aadhaar_back" accept="image/*,application/pdf" placeholder="acc_no" onChange={handleFileChange} />
                                    </div>
                                </div>

                                <h5 className="mt-4">Other Details</h5>
                                <hr />
                                <div className="row g-3">

                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="pf_no" placeholder="PF Number" value={form.pf_no} onChange={handleInputChange} />
                                    </div>



                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="fax" placeholder="Fax" value={form.fax} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control" name="url" placeholder="URL" value={form.url} onChange={handleInputChange} />
                                    </div>

                                      <div className="col-md-4">
                                        <label>Enter Your GST Number</label>
                                        <input type="text" className="form-control" name="gst" placeholder="GST" value={form.gst} onChange={handleInputChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label" > Upload Your GST image or pdf</label>

                                        <input type="file" className="form-control   " name="gst_img" accept="image/*,application/pdf" onChange={handleFileChange} />
                                    </div>

                                     <div className="col-md-4">
                                        <label>Enter Your Light Bill</label>
                                        <input type="text" className="form-control" name="bill" placeholder="Enter Your Light Bill" value={form.bill} onChange={handleInputChange} />
                                    </div>
                                       <div className="col-md-4">
                                        <label>Upload Your Light Bill</label>
                                        <input type="file" className="form-control" name="bill_img" accept="image/*,application/pdf" onChange={handleFileChange} />
                                    </div>

                                </div>
                                <div className="col-md-12 text-end">
                                    <button className='btn btn-primary' type='submit' >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>

                    </div>
                         </div>

           </div>
        </>
    )
}

export default EditEmp
